'use client';
import { createContext, PropsWithChildren, useContext } from 'react';
import { TestimonialConfig } from '../type';
import { textsMapper } from '../textsMapper';

const TestimonialContext = createContext<TestimonialConfig>({
  texts: textsMapper(undefined),
});

type TestimonialProviderProps = {
  config: TestimonialConfig;
};

export const TestimonialProvider = ({
  children,
  config,
}: PropsWithChildren<TestimonialProviderProps>) => (
  <TestimonialContext.Provider value={config}>
    {children}
  </TestimonialContext.Provider>
);

export const useTestimonialConfig = () => useContext(TestimonialContext);
